import { Component } from '@angular/core';
import { ICollapsableNavItem } from '../../../../../../../core/src/lib/components/collapsable-nav/collapsable-nav.component';
import { CollapsableNavCardComponent } from '../../../../../../../core/src/lib/components/collapsable-nav/collapsable-nav-card/collapsable-nav-card.component';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'app-menu-page-supervisor',
  imports: [CollapsableNavCardComponent, NzGridModule],
  templateUrl: './menu-page-supervisor.component.html',
  styleUrl: './menu-page-supervisor.component.scss',
})
export class MenuPageSupervisor {
  public navItem: ICollapsableNavItem = {
    title: 'Pregled dokumenata za provjeru',
    icon: 'file',
    route: '/authorisations-page-supervisor',
    description:
      'Pregled prava za zastupanje i prava pristupa na e-uslugu koji čekaju provjeru skupnog potpisivanja Kontrolora skupnog potpisa',
  };
}
